export enum DocumentReportFilterType {
  COMPLETED_ON_TIME = 1,
  OVERDUE = 2,
  IN_PROGRESS = 3,
  REJECTED = 4,
}

export enum SystemReportTypeCode {
  PROCESS_REPORT = 0,
  DOCUMENT_REPORT = 1,
  PROCESS_STATUS_REPORT = 2,
  SYSTEM_REPORT = 3,
  ROLE_REPORT = 4,
  DETAIL_DOCUMENT_REPORT = 5,
  SEWS_DETAIL_REPORT = 6,
}

export enum ReportTemplateType {
  DOCUMENT_EXPORT = "DOCUMENT_EXPORT",
  PROCESS_REPORT = "PROCESS_REPORT",
  DOCUMENT_REPORT = "DOCUMENT_REPORT",
  PROCESS_STATUS_REPORT = "PROCESS_STATUS_REPORT",
  SYSTEM_REPORT = "SYSTEM_REPORT",
  ROLE_REPORT = "ROLE_REPORT",
  DETAIL_DOCUMENT_REPORT = "DETAIL_DOCUMENT_REPORT",
  SEWS_DETAIL_REPORT = "SEWS_DETAIL_REPORT",
}

export const SYSTEM_REPORT_TEMPLATE_TYPES: string[] = [
  ReportTemplateType.PROCESS_REPORT,
  ReportTemplateType.DOCUMENT_REPORT,
  ReportTemplateType.PROCESS_STATUS_REPORT,
  ReportTemplateType.SYSTEM_REPORT,
  ReportTemplateType.ROLE_REPORT,
  ReportTemplateType.DETAIL_DOCUMENT_REPORT,
  ReportTemplateType.SEWS_DETAIL_REPORT,
];

export type DocumentReportFieldKey =
  | "id"
  | "documentNumber"
  | "creatorFullName"
  | "title"
  | "subCategoryName"
  | "receiversNames"
  | "subdivisionName"
  | "esedoSenderName"
  | "status"
  | "incomingNumber"
  | "outgoingNumber"
  | "executors"
  | "deadline"
  | "finishedAt";

export type DocumentReportFieldConfig = Record<DocumentReportFieldKey, boolean>;

export interface DocumentReportParamConfig {
  type?: string | number | null;
  documentCategoryId?: string | null;
  subCategory?: string | null;
  createdAtStart?: string | null;
  createdAtEnd?: string | null;
  finishedAtStart?: string | null;
  finishedAtEnd?: string | null;
}

export interface DocumentReportExportPayload {
  filename?: string;
  fieldConfig: DocumentReportFieldConfig;
  paramConfig: DocumentReportParamConfig;
}

export interface DocumentReportListItem {
  id: string;
  documentNumber: string;
  creatorFullName: string;
  subCategoryName: string;
  receiversNames: string;
  subdivisionName: string;
  esedoSenderName: string;
  incomingNumber: string;
  outgoingNumber: string;
  executors: string;
  deadline: string;
  finishedAt: string;
}

export interface ReportTemplate {
  id?: string;
  name: string;
  reportType: ReportTemplateType | string;
  fieldConfig: DocumentReportFieldConfig | Record<string, never>;
  paramConfig: DocumentReportParamConfig | SystemReportParamConfig;
}

export interface SystemReportType {
  id?: number;
  type: number;
  code: string;
  name?: string;
}

export interface SystemReportConfig {
  type: number;
  code: string;
  startFilters: string[];
  permission?: Record<string, boolean>;
}

export interface SystemReportParamConfig {
  type?: number;
  reportType?: string;
  name?: string;
  timeType?: number;
  startDate?: string;
  endDate?: string;
  constructorIds?: string[];
  category?: string[];
  companyIds?: string[];
  branch?: string[];
  roleIds?: string[];
  roles?: string[];
  processTemplateIds?: string[];
  processType?: string[];
  isSigning?: boolean;
  sewsType?: number;
}

export interface SystemReportPreview {
  type: number;
  reportType: string;
  title: string;
  columns: string[];
  rows: Record<string, string>[];
  meta: Record<string, unknown>;
}
